/* Souss & Stone — Lenis smooth scroll (step 1 only) */
(function () {
  'use strict';

  /* Bail out immediately for users who prefer less motion */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function initLenis() {
    if (typeof Lenis === 'undefined') {
      /* Lenis CDN not ready yet — wait one frame */
      requestAnimationFrame(initLenis);
      return;
    }

    var lenis = new Lenis({
      lerp: 0.09,          /* smoothness: 0 = instant, 1 = never arrives */
      smoothWheel: true,   /* smooth on mouse wheel                       */
      smoothTouch: false,  /* native scroll on touch / mobile swipe       */
    });

    /* Standard RAF loop — required for Lenis to tick */
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    /* Expose so other scripts can call lenis.scrollTo() if needed */
    window._lenis = lenis;

    /*
     * Lenis caches the page's scrollable height at init. Content that
     * finishes loading or resizing afterward (lazy images, the Judge.me
     * review widget, the Appstle Loyalty rewards badge, Shopify's payment-button
     * component, cart section re-renders, accordion expand/collapse) can
     * grow the real page past what Lenis thinks the limit is -- the
     * native scrollbar looks like it has room, but scroll input stops
     * responding before reaching the actual bottom. Force a recalculation
     * whenever the document's rendered height changes.
     */
    var resizeRaf = null;
    function scheduleResize() {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        if (typeof lenis.resize === 'function') lenis.resize();
      });
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleResize).observe(document.body);
    }
    window.addEventListener('load', scheduleResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLenis);
  } else {
    initLenis();
  }
})();
